/**
 * Accessible toggle switch (role="switch"), used for "Seller Mode".
 * Renders as a real button so keyboard and screen-reader behaviour is native.
 */
export default function ToggleSwitch({ checked, onChange, label, id, disabled = false }) {
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors duration-200 ${
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      } ${
        checked
          ? 'bg-brand-600 shadow-[0_0_0_4px_var(--z2-brand-soft)]'
          : 'bg-line-2 hover:bg-ink-3/40'
      }`}
    >
      <span
        aria-hidden="true"
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-sm transition-transform duration-200 ${
          checked ? 'translate-x-[22px]' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
}
